const moneyFormat = (money:any) => {
    if(money){
        return money?.toLocaleString(undefined, {minimumFractionDigits: 2}) + "₺";
    } else {
        let num = 0;
        return num.toLocaleString(undefined, {minimumFractionDigits: 2}) + "₺";
    }
}

export {moneyFormat}
export const safelyParseNumber = (value:any) => {
    if (value === null || value === undefined || value === "") return null;
    const parsed = Number(value);
    return isNaN(parsed) ? null : parsed;
  };

  export const sortDataByField = (data: any[], fieldName: string): any[] => {
    const collator = new Intl.Collator("tr", { sensitivity: "base" });
    return data.sort((a: any, b: any) => collator.compare(a[fieldName], b[fieldName]));
  };